'use client';

import { Box } from '@wishket/design-system';

import NewLandingTitle from '../NewLandingTitle/NewLandingTitle';

import UsageCard from './UsageCard';
import { Mail, Slackbot, Scrap, Bulb } from './Images';

import { PATH } from '@/shared/constants';
import { useDeviceCheck } from '@/shared/hooks';

const usageCards = [
  {
    title: '스크랩',
    description: {
      default: '다시 읽고 싶은\n콘텐츠 꺼내보기',
      desktop: '다시 읽고 싶은 콘텐츠\n간편하게 꺼내보기',
    },
    imageComponent: <Scrap />,
    link: process.env.NEXT_PUBLIC_APP_DETAIL_SCRAP_USAGE_URL || '',
  },
  {
    title: '성장 습관',
    description: {
      default: '원하는 시간에\n받는 신규 콘텐츠',
      desktop: '원하는 시간에\n받는 신규 콘텐츠',
    },
    imageComponent: <Mail />,
    link: process.env.NEXT_PUBLIC_APP_DETAIL_MAIL_USAGE_URL || '',
  },
  {
    title: '슬랙봇',
    description: {
      default: '동료와 함께\n읽고 싶을 때',
      desktop: '성장을 위한 콘텐츠\n동료와 함께 읽고 싶을 때',
    },
    imageComponent: <Slackbot />,
    link: PATH.SLACKBOT,
  },
  {
    title: '물어봐 AI',
    description: {
      default: '일하다 막힐 때\n바로 찾는 지식',
      desktop: '일하다 막힐 때\n바로 찾는 실무 지식',
    },
    imageComponent: <Bulb />,
    link: PATH.QUESTIONS,
  },
];

const Usage = () => {
  const { isDesktop } = useDeviceCheck();

  return (
    <Box className="flex flex-col gap-6" data-testid="landing-usage">
      <NewLandingTitle title="요즘IT 활용 백서" />

      <Box className="grid grid-cols-2 gap-5 tablet:flex tablet:gap-5">
        {usageCards.map((usageCard) => (
          <UsageCard
            key={usageCard.title}
            {...usageCard}
            description={
              isDesktop
                ? usageCard.description.desktop
                : usageCard.description.default
            }
          />
        ))}
      </Box>
    </Box>
  );
};

export default Usage;
